import { Evolution } from "../../../redux/evolutions/evolutionsSlice";
import axios from "../../apiFc24";

export type EvolutionsResponse = Evolution[];

export const getEvolutions = async () => {
  const res = await axios.get<EvolutionsResponse>("/evolutions");
  return res.data;
};
